var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "img-swiper" }, [
    _vm.edit
      ? _c(
          "div",
          {
            staticClass: "swiper-upload",
            on: { click: _vm.upload, change: _vm.handleFile }
          },
          [
            _c("input", {
              staticStyle: { display: "none" },
              attrs: {
                type: "file",
                id: _vm.id,
                accept: "image/png, image/jpeg, image/jpg"
              }
            }),
            _vm._v(" "),
            _c("i", { staticClass: "el-icon-plus add-plus" })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "swiper-img-content"
      },
      [
        _c(
          "swiper",
          {
            ref: "swiper",
            staticClass: "swiper",
            attrs: { options: _vm.swiperOption }
          },
          [
            _vm._l(_vm.imgList, function(item, key) {
              return _c("swiper-slide", { key: key }, [
                _c(
                  "div",
                  { staticClass: "img-content" },
                  [
                    _c("el-image", {
                      staticClass: "img-content-el-img",
                      attrs: { src: item, "preview-src-list": _vm.imgList }
                    }),
                    _vm._v(" "),
                    _vm.edit
                      ? _c("i", {
                          staticClass: "el-icon-error img-content-colse",
                          on: {
                            click: function($event) {
                              return _vm.deleteImg(key)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-button-prev swiper-button-grey",
              attrs: { slot: "button-prev" },
              slot: "button-prev"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-button-next swiper-button-grey",
              attrs: { slot: "button-next" },
              slot: "button-next"
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d974934", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d974934","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/img-swiper-review.vue
// module id = OHCE
// module chunks = 2